import { NgModule } from '@angular/core';
import { PicInitialsPipe } from './pic-initials/pic-initials.pipe';

@NgModule({
  imports: [],
  declarations: [ 
    PicInitialsPipe
  ],
  exports: [
    PicInitialsPipe
  ]
})
export class CustomPipesModule {}